import AccordionSectionPresentationPropsDefault from "@insite/mobius/AccordionSection/presentationProps";
import { ComponentThemeProps } from "@insite/mobius/globals/baseTheme";
import Minus from "@insite/mobius/Icons/Minus";
import Plus from "@insite/mobius/Icons/Plus";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import ChevronDown from "@tSurya/MobiusOverrides/Icons/ChevronDown";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

const AccordionPresentationPropsDefaultCustom: ComponentThemeProps["accordion"]["sectionDefaultProps"] = {
    titleTypographyProps: {
        variant: "body",
        forwardAs: "span",
        fontFamily: "Mulish",
        transform: "capitalize",
        css: css`
            size: ${TYPOGRAPHY.size.large};
            color: ${getColor("text.main")};
            line-height: ${TYPOGRAPHY.lineHeight.medium};
            weight: ${TYPOGRAPHY.weight.bold};
        `,
    },
    headerProps: {
        css: css`
            button {
                background-color: ${getColor("secondary")};
            }
        `,
    },
    toggleIconProps: {
        src: Minus,
        size: 14,
        css: css`
            vertical-align: text-top;
        `,
    },
    expandIconProps: {
        src: Plus,
        size: 14,
        css: css`
            vertical-align: text-top;
        `,
    },
    panelProps: {
        css: css``,
    },
};
export default {
    defaultProps: {},
    sectionDefaultProps: AccordionPresentationPropsDefaultCustom,
};
